import { HomeLayoutComponent } from './layout/home/home-layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/passport/login/login.component';
import { CanActivateHandler } from './core/services/can-activate-handler.service';
import { LayoutpassportComponent } from './layout/passport/layoutpassport.component';
import { SharedModule } from './shared/shared.module';
import { ForgetpasswordComponent } from './pages/passport/forgetpassword/forgetpassword.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';



const routes: Routes = [
  {
    path: '', canActivate: [CanActivateHandler],
    component: HomeLayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard/default', pathMatch: 'full' },
      { path: 'dashboard', redirectTo: 'dashboard/default', pathMatch: 'full' },
      { path: 'dashboard/default', loadChildren: () => import('./pages/dashboard/default/default.module').then(m => m.DefaultModule) },
      { path: 'exception', loadChildren: () => import('./pages/exception/exception.module').then(m => m.ExceptionModule) },
      { path: 'account', loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule) },
      { path: 'manager', loadChildren: () => import('./pages/manager/manager.module').then(m => m.ManagerModule) },
      { path: 'codebuild', loadChildren: () => import('./pages/codebuild/codebuild.module').then(m => m.CodebuildModule) },
      { path: 'jobs', loadChildren: () => import('./pages/jobs/jobs.module').then(m => m.JobsModule) }
    
      ,{ path: 'systest', loadChildren: () => import('./pages/systest/systest.module').then(m => m.SysTestModule) },
    
      { path: 'appvideo', loadChildren: () => import('./pages/appvideo/appvideo.module').then(m => m.AppVideoModule) },
    
      { path: 'apptypes', loadChildren: () => import('./pages/apptypes/apptypes.module').then(m => m.AppTypesModule) },
    
      { path: 'appgoods', loadChildren: () => import('./pages/appgoods/appgoods.module').then(m => m.AppGoodsModule) },
    
      { path: 'appyibiaopan', loadChildren: () => import('./pages/appyibiaopan/appyibiaopan.module').then(m => m.AppYiBiaoPanModule) },
    
      { path: 'appgoodsdetail', loadChildren: () => import('./pages/appgoodsdetail/appgoodsdetail.module').then(m => m.AppGoodsDetailModule) },
    ]
  },
  { path: 'cloudpipeline', loadChildren: () => import('./pages/cloudpipeline/cloudpipeline.module').then(m => m.CloudpipelineModule) },
  {
    path: 'passport',
    component: LayoutpassportComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: { title: '登录', titleI18n: 'app.login.login' },
      },
      {
        path: 'forgetpassword',
        component: ForgetpasswordComponent,
        data: { title: '忘记密码', titleI18n: 'app.forgetpassword.forgetpassword' }
      }
    ]
  },
  // { path: 'im', loadChildren: () => import('./core/common/app-im-moblie/app-im-moblie.module').then(m => m.AppImMoblieModule) },
 


  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [SharedModule, RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  declarations: [LoginComponent, ForgetpasswordComponent],
  providers: [CanActivateHandler]
})
export class AppRoutingModule { }
